import { Typography } from '@libs/components';
import { useTranslation } from 'src/hooks';
import { useTheme } from 'styled-components';
import { AssetContainer, ChangeButton, AssetRows, AssetIcon } from './styles';

type AssetRowProps = {
  label: string;
  icon?: string | JSX.Element;
  amount?: string | number;
  onChange: () => void;
  className?: string;
};
const AssetRow: React.FC<AssetRowProps> = ({
  amount,
  label,
  icon,
  className,
  onChange,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <AssetContainer className={className}>
      <div>
        <Typography
          type="caption"
          fontWeight={500}
          fontFamily="primaryMedium"
          color={colors.text.secondary}
        >
          {label}
        </Typography>
        <AssetRows>
          <div className="icon">
            {typeof icon === 'string' ? (
              <AssetIcon className="asset-icon" src={icon} />
            ) : (
              icon
            )}
          </div>
          <Typography
            type="titleTwo"
            fontFamily="primaryBold"
            color={colors.text.default}
          >
            {' '}
            {amount}
          </Typography>
        </AssetRows>
      </div>

      <ChangeButton
        size="sm"
        buttonType="secondary"
        title={t('account_info_button')}
        onClick={onChange}
      />
    </AssetContainer>
  );
};

export default AssetRow;
